import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

import Widgets from "components/widgets";
import AdvancedSettings from "components/settings";
import ContentSelection from "components/contentSelection";
import { generateAnonymousLinksRequest } from 'actions/links';
import { attachContent } from 'services/messages.service';
import CollectionWidgetManager from 'services/collections.widget.service';
import { PF_CHROME_OPEN_COMPOSE, PF_CHROME_WEBAPP_ATTACH_ASSETS } from "constants/actionTypes";
import NDAList from "components/nda";

import cx from 'classnames';
import styles from './attachAsset.module.scss';
import _ from "lodash";

const widgetManager = new CollectionWidgetManager();

export default function AttachAsset(props) {
const dispatch = useDispatch();
const history = useHistory();

 const [attaching, setAttaching] = useState(false);

 const applicationContext = useSelector(state => _.get(state, `application`));
 const assets = useSelector(state => _.get(state, `application.assets`, []));
 const source = useSelector(state => _.get(state, `application.type`));
 const collection = useSelector(state => _.get(state, `application.collection`, null));
 const selectedItems = useSelector(state => _.get(state, `selection.selectedItems`));
 const selectedItemsContent = useSelector(state => _.get(state, `selection.selectedItemsContent`));

 const empty = collection == null && assets.length == 0;

 const [showNDAList, setShowNDAList] = useState(false);
 const [nda, setNda] = useState(null);

const triggerMessageToPlugin = (message) => {
  window.parent.postMessage(message, "*");
}

  const handleAttachContent = async () => {
    setAttaching(true);
  
    const request = {
      type: "anonymous",
      ...(applicationContext.settings || {}),
    };
  
    var entities = [];
    if (collection) {
      entities = [collection];
    } else if (assets.length > 0) {
      entities = [...assets];
    }
  
    const generateLinks = (entities, request) => {
      return new Promise((resolve, reject) => {
        dispatch(generateAnonymousLinksRequest(entities, request, (response) => {
          const html = widgetManager.widget(response.widget).render(response);
          var context = {
            ...response,
            html: html
          }
          
          context = JSON.parse(JSON.stringify(context));
          
          triggerMessageToPlugin({
            type: PF_CHROME_OPEN_COMPOSE,
            payload: context,
          })
         
          setTimeout(() => {
          triggerMessageToPlugin({
            type: PF_CHROME_WEBAPP_ATTACH_ASSETS,
            payload: context,
          });
          }, 1000);
        
        setAttaching(false);
        resolve();
        }));
      });
    };
  
    try {
      await generateLinks(entities, request);
      history.push('/paperflite-content-library');
    } catch (error) {
      console.error("An error occurred");
    }
  };

  const handleNDAClick = () => {
    if(nda != null) {
      setNda(null);
    } else {
      setShowNDAList(!showNDAList);
    }
  }

  const handleNDAChange = () => {
    setShowNDAList(!showNDAList);
  }

  const handleNdaSelection = (nda) => {
    setNda(nda);
    setShowNDAList(!showNDAList);
  }

  const handleBackClicked = () => {
    history.push('/paperflite-content-library');
  }

  return (
    <div className={styles.container}>
        <p className={styles.headerContainer}>
        {showNDAList &&
          <div className={styles.nda}>
            <Button variant='link' onClick={() => setShowNDAList(!showNDAList)}>
              <FontAwesomeIcon icon={faChevronLeft} size="sm" /> NDA Templates
            </Button>
            <NDAList onNDASelection={(nda) => handleNdaSelection(nda)}/>
          </div>
        }

          <span className={styles.backButton} onClick={() => handleBackClicked()}>
          <i className="paperflite-left-arrow"/>
          <span className={styles.back}>
            attaching assests
          </span>
          </span>
        </p>
        <div className={styles.contentSelection}>
        <ContentSelection />
        </div>
        <Widgets />
        <AdvancedSettings onNDAToggle={handleNDAClick} nda={nda} source={source} onNDAChange={handleNDAChange}/>
        <div className={styles.actionsContainer}>
            <button className={styles.attachButton} onClick={() => handleAttachContent()}> 
            <i className={cx("paperflite-send", styles.attachIcon)}></i> 
              {attaching ? 'Attaching...' : 'Attach'}
            </button>
        </div>
    </div>
  );
}